<template>
	<app-button theme="warning" size="x-small" @click="open = true">
		<app-icon :icon="['fas', 'fa-info-circle']" />
	</app-button>

	<teleport to="body">
		<slideover :title="title" :open="open" @close="open = false">
			<div v-for="status in statuses" :key="status.key" class="mb-5">
				<h5 class="font-semibold text-mabey-950 text-sm">{{ status.label }}</h5>
				<ul role="list" class="divide-y divide-gray-100">
					<li
						v-for="(description, key, index) in status.icons"
						:key="index"
						class="flex justify-between gap-x-6 py-5">
						<div class="flex items-center min-w-0 gap-x-4">
							<div class="w-10">
								<app-svg
									:key="index"
									:path="`/icons/catalyst/${getIcon(status.code, key).icon}.svg`"
									:colour="key === 'load' ? '#002855' : undefined"
									:background="getIcon(status.code, key).colour"
									autoscale />
							</div>

							<div class="min-w-0 flex-auto">
								<p class="text-sm font-medium leading-6 text-gray-900">
									{{ description }}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</slideover>
	</teleport>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue'
	import type { WorkspaceArea } from '@/data/types/area'
	import { statusMap } from '@/utils/statusMaps'
	import AppSvg from '@/components/base/AppSvg.vue'
	import { useContractStatus } from '@/composables/status'

	const props = withDefaults(
		defineProps<{
			title: string
			workspace: 'hire-desk' | 'yard'
			area: WorkspaceArea
		}>(),
		{
			title: 'Status Key',
			area: 'stock-check'
		}
	)

	const open = ref(false)

	const statuses = computed(() => {
		const filteredStatuses: Array<{
			key: string
			code: number
			label: string
			icons: { [key: string]: string }
		}> = []

		for (const key in statusMap) {
			const action = statusMap[key]
			const variants = action.status[props.workspace]?.[props.area]

			if (variants) {
				filteredStatuses.push({
					key: key,
					code: action.code,
					label: action.label,
					icons: variants
				})
			}
		}

		return filteredStatuses
	})

	function getIcon(status: number, sub: any) {
		const { icon, colour } = useContractStatus(status, sub)

		return {
			icon: icon.value,
			colour: colour.value
		}
	}
</script>
